import { getToken, setToken, removeToken } from '@/utils/auth'
const admin = {
    state: {
      token: getToken(),
      userInfo:{},
      openId: '',
      mobile:'',
      userId:'',
      referral_code:'',
      permissionStatus: false,
      customerOpenIdinclude: false
    },
    mutations: {
      SET_TOKEN: (state, token) => {
        state.token = token
      },
      saveUser:(state, obj) => {
        state.userInfo = obj;
      },
      saveQrcodePath:(state, path) => {
       state.userInfo.shareQrcodePath = path;
     },
      setOpenId:(state, id) => {
        state.openId = id;
      },
      set_referral_code:(state, referral_code) => {
        state.referral_code = referral_code;
      },
      set_user_id:(state, userId) => {
        state.userId = userId;
      },
      set_Mobile:(state, mobile) => {
        state.mobile = mobile;
      },
      setPermissionStatus: (state, bl) => {
        state.permissionStatus = bl;
      },
      setcustomerOpenIdinclude: (state, isExists) => {
        state.customerOpenIdinclude = isExists;
      },
    },
   actions:{
      SAVEUSER: ({commit},obj)=>{
        commit('saveUser',obj)
      },
   }
 }
 
 export default  admin
 